<template>
  <div>
    <router-view />
    <div class="q-pa-md q-mt-xl q-pt-md" :v-if="price">
      
      <div class="introWindow row justify-evenly">
         <div class="col-5 cards">
          <div class="col-12"> 
            <h5>Online mode</h5>
            <p>This mode is only for <span> shopify retailers</span>. Only on installing the app, the app will be able to get the details of products listed in your shopify store.</p>
            <p>Follow the steps below to apply price optimisation:</p>
            <ul>
              <li>Select online mode.</li>
              <li>Select any one of the options <span>( revenue , volume , profit )</span>.</li>
              <li>Select the product/products ( enter inputs like mrp or cost for options profit and volume optimisation).</li>
              <li>Click on <span>" Add to price optimisation"</span>.</li>
              <li>Wait for the result.</li>
              <li>Check all the results and history from <span> result history </span> page.</li>
            </ul>
          </div> 

          <div class="col-12">
            <router-link
              :to="home"
              style="text-decoration: none; color: inherit"
            >
              <div class="card-i">
                <img class="cardimg" src="../../assets/online.png" />
                <q-tooltip>
                 Click here to enter into online mode
                </q-tooltip>

                <q-card-section @click="selectmode('Online')"> Online </q-card-section>
              </div>
            </router-link>
          </div>
         </div>
         
         <div class="col-5 cards">
           <div class="col-12"> 
             <h5>Offline mode</h5>
             <p>This mode can be used by <span>any retailers</span> those have historical data available in <span>excel or csv</span> file format . </p>
            <p>Follow the steps below to apply price optimisation:</p>
            <ul>
              <li>Select offline mode. </li>
              <li>Select any one of the options <span>( revenue , volume , profit )</span>.</li>
              <li>Upload the files in required format specified in respective options.</li>
              <li>Click on <span>" Submit "</span>.</li>
              <li>Wait for the result.</li>
              <li>Check all the results and history from <span>result history</span> page.</li>
            </ul>
          </div>
          <div class="col-12">
            <router-link
              :to="offline"
              style="text-decoration: none; color: inherit"
            >
              
              <div class="card-i">
                <img class="cardimg" src="../../assets/offline.png" />
                <q-tooltip>
                 Click here to enter into offline mode
                </q-tooltip>

                <q-card-section @click="selectmode('Online')">Offline</q-card-section>
              </div>
              
            </router-link>
          </div>
        <div>  
        </div>
        <h3></h3>
       
      

       
      </div>
    </div>
  </div>

  </div>
</template>

<script>
export default {
  computed:{
    home(){
      return { path:'/priceoptimization/home/' + this.$org_encryprt.label};
    },
    offline(){
      return {path:'/priceoptimization/offline/' + this.$org_encryprt.label};
    },
    
  },
  mounted(){
      this.$q.loading.show({
       message: "Authenticating please wait..",
     });

      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
          this.$store.dispatch("setPathName", "/priceoptimization/select");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
          this.$store.dispatch("setPathName", "/priceoptimization/select");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
          this.$store.dispatch("setPathName", "/priceoptimization/select");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else{

       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

     }

    },
    methods:{
      selectmode(select){
        this.$mixpanel.track(`${select}`, {
      info: `User entered ${select}`,
    });

      }

    },
  

  
};
</script>

<style  scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.q-card__section--vert {
  padding: 0;
 
}
.q-card-section{
    size:2rem;
  
  color:rgb(0, 88, 252);
}
/*li span {
      position: relative;
      left: +100px;
}*/

.q-scrollarea {
    position: relative;
    align-items: center;

    margin: auto;
}

.q-scrollarea {
    position: relative;
    margin: auto;
}
h5{
  text-align: center;
  margin-top: 20px;
  font-size:32px;
  color:rgb(33, 103, 233);
  font-family: "Poppins", sans-serif !important;
}
h4{
    color:rgb(147, 24, 158);
    
}
/* Float four columns side by side */
.column {
  float: left;
  height:8rem;
  width:100%;
  max-height: 10rem;
  max-width: 10rem;
  padding: 0 10px;
}

.cards {
  background-color: white;
  border-radius: 5px;
  
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

span {
  font-weight:500;
}


/* Responsive columns */
@media screen and (max-width: 600px) {
  .column {
    width: 100%;
    display: block;
    margin-bottom: 20px;
  }
}

/* Style the counter cards */
.card-i {
  box-shadow: rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  background-color:#f8f6f6;
  width: auto;
  max-height: 8rem;
  max-width: 8rem;
  margin: auto;
  transition:all 500ms ease;
  margin-top: 20px;
}
.card-i:hover{
  background-color: #e6e3e3;
}

.scroll {
  margin: auto;
  width: 80%;
  background: #f9f6f7;
  border-radius: 10px;
  box-shadow: 0px 5px 15px -2px rgb(26 108 220);
}

.cardimg {
  text-align: center;
  margin: auto;
  height: 3rem;
  width: 3rem;
  min-height: 50px;
  min-width: 50px;
  margin-top: 10px;
}

.icon {
  text-align: center;
  margin: auto;
  height: 1rem;
  width: 1rem;
  min-height: 15px;
  min-width: 15px;
  /*margin-top: 10px;*/
}

.introWindow {
  
  background: transparent;
}
/* .row {
  max-width: 50%;
  margin-top: 3rem;
  margin-bottom: 2rem;
  margin-left: auto;
  margin-right: auto;
} */
.q-page-container {
  height: 100vh;
  overflow: hidden;
}

.flex-container {
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  max-width: 60%;
  margin: 1rem auto;
}

@media (max-width: 400px) {
  .flex-container {
    flex-direction: column;
  }
}
</style>
